import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

const HUB_CONNECTION_ACTIONS = {
  startStatusUpdate: function (store) {
    store.commit('resetNodeStates');
    var hubCount = store.state.hubs.length;
    for(var i = 0;i < hubCount; i++){
      store.dispatch('resetHubStates', i);
      store.dispatch('updateHubNodeStatus', store.state.hubs[i].uuid);
    }
  },
  resetHubStates: function (store, hubIndex) {
    store.commit('setHubStatus', {
      hubIndex: hubIndex,
      connectionStatus: {
        local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
        online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
      },
      stateUpdatePending: false,
      //ipAddress: null,
      firmWareYear: null,
      firmWareMonth: null,
      isMQTTConnected: null,
      wifiType: null,
      ssid: null,
      dateStamp: null,
      timeStamp: null,
      networkAddress: null,
      // ioInfo: null
    });
  },
  updateHubNodeStatus: function (store, hubUUID) {
    var hub = store.getters.getHubByUUID(hubUUID);
    if(hub != -1){
      var connectionStatus = hub.connectionStatus;
      if( connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED && connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED){
        // console.log('start connection');
        store.dispatch('checkHubConnectionStatusLocal', hub.uuid);
        store.dispatch('checkHubConnectionStatusOnline', hub.uuid);
      }else if( connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING && connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING){
        // console.log('connecting');
      }else if(connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED || connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        if(hub.stateUpdateEnabled && !hub.stateUpdatePending){
          store.commit('setHubStatus', {
            hubIndex: hub.index,
            stateUpdatePending: true,
          });
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: hub.psk,
            destinationUUID: hub.uuid,
            sourceUUID: store.state.user.uuid
          });
          store.dispatch('getNodeListAndStates', {messagingHook: messagingHook,hubUUID: hub.uuid})
          .then( response => {
            // console.log(response);
            var nodeStats = response.body.bodyContent.nodeStats;
            nodeStats.hubIndex = response.hubIndex;
            if(hub.stateUpdateEnabled){
              store.dispatch('processNodeListAndStates', nodeStats)
            }
          }).catch( response => {
            // console.log(response);
            store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          })
          .finally( () => {
            store.commit('setHubStatus', {
              hubIndex: hub.index,
              stateUpdatePending: false,
            });
          });
        }
      }
      setTimeout( () => {
        store.dispatch('updateHubNodeStatus', hubUUID);
      }, CONFIGS.UPDATE_HUB_NODE_STATUS_INTERVAL_TIME);
    }
  },
  checkHubConnectionStatusLocal: function (store, hubUUID) {
    var hub = store.getters.getHubByUUID(hubUUID);
    var hubIndex = hub.index;
    store.commit('setHubStatus', {
      hubIndex: hubIndex,
      connectionStatus: {
        local: CONFIGS.HUB_CONNECTION_STATUS_CONNECTING,
      },
    });
    store.dispatch('resolveHubAddress', hubUUID)
    .then( response => {
      store.commit('setHubStatus', {
        hubIndex: response.hubIndex,
        networkAddress: response.networkAddress,
      });
      var messagingHookLocal = new Messaging(new Logger(false));
      messagingHookLocal.init({
        psk: store.state.hubs[hubIndex].psk,
        destinationUUID: store.state.hubs[hubIndex].uuid,
        sourceUUID: store.state.user.uuid
      });
      console.log("readHubParameters + ip  = ", hub.staticIp );
      store.dispatch('readHubParameters', {connectionType: 'Local',messagingHook: messagingHookLocal,hubUUID: store.state.hubs[hubIndex].uuid})
      .then( response => {
        console.log("readHubParameters => ")
        console.log( response)
        store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_CONNECTED,
          },
          ipAddress: hub.staticIp ?  hub.ipAddress : response.body.bodyContent.hubIP[0] + '.' + response.body.bodyContent.hubIP[1] + '.' + response.body.bodyContent.hubIP[2] + '.' + response.body.bodyContent.hubIP[3] ,
          firmWareYear: response.body.bodyContent.firmwareYear,
          firmWareMonth: response.body.bodyContent.firmwareMonth,
          isMQTTConnected: response.body.bodyContent.isMQTTConnected == 1 ? true : false,
          wifiType: response.body.bodyContent.wifiType == 0 ? "STA" : "AP",
          ssid: response.body.bodyContent.ssid,
          dateStamp: response.header.nonce.dateStamp,
          timeStamp: response.header.nonce.timeStamp,
          ioInfo: response.body.bodyContent.ioInfo
        });
        store.dispatch('updateNodeListAndStates', response.hubIndex)
        .then( (response) => {
          var nodeStats = response.body.bodyContent.nodeStats;
          nodeStats.hubIndex = response.hubIndex;
          store.dispatch('processNodeListAndStates', nodeStats);
          // store.dispatch('updateAutomations', response.hubIndex)
          // .catch( (response) => {
          //   store.commit('setHubStatus', {
          //     hubIndex: response.hubIndex,
          //     connectionStatus: {
          //       local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          //     },
          //   });
          //   setTimeout( () => {
          //     //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
          //     store.dispatch('checkHubConnectionStatusLocal', store.state.hubs[hubIndex].uuid);
          //   }, CONFIGS.updateHubNodeStatusIntervalTime);
          // });
        })
        .catch( (err) => {
          console.log(err);
          store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
          setTimeout( () => {
            //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
            store.dispatch('checkHubConnectionStatusLocal', store.state.hubs[hubIndex].uuid);
          }, CONFIGS.updateHubNodeStatusIntervalTime);
        });
      })
      .catch( response => {
        if(store.state.hubs[response.hubIndex].connectionStatus.online != CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
          setTimeout( () => {
            //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
            store.dispatch('checkHubConnectionStatusLocal', store.state.hubs[hubIndex].uuid);
          }, CONFIGS.updateHubNodeStatusIntervalTime);
        }else{
          store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
      });
    })
    .catch( response => {
      console.log(response)
      if(store.state.hubs[response.hubIndex].connectionStatus.online != CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        setTimeout( () => {
          store.dispatch('checkHubConnectionStatusLocal', store.state.hubs[response.hubIndex].uuid);
        }, CONFIGS.updateHubNodeStatusIntervalTime);
      }else{
        store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    });
  },
  checkHubConnectionStatusOnline: function (store, hubUUID) {
    var hub = store.getters.getHubByUUID(hubUUID);
    var hubIndex = hub.index;
    store.commit('setHubStatus', {
      hubIndex: hubIndex,
      connectionStatus: {
        online: CONFIGS.HUB_CONNECTION_STATUS_CONNECTING,
      },
    });
    var messagingHookOnline = new Messaging(new Logger(false));
    messagingHookOnline.init({
      psk: store.state.hubs[hubIndex].psk,
      destinationUUID: store.state.hubs[hubIndex].uuid,
      sourceUUID: store.state.user.uuid
    });
     console.log("readHubParameters + ip  = ", hub.ipAddress );
    store.dispatch('readHubParameters', {connectionType: 'Online',messagingHook: messagingHookOnline,hubUUID: store.state.hubs[hubIndex].uuid})
    .then( response => {
      // console.log("readHubParameters reponse =>", response)
      store.commit('setHubStatus', {
        hubIndex: response.hubIndex,
        connectionStatus: {
          online: CONFIGS.HUB_CONNECTION_STATUS_CONNECTED,
        },
        ipAddress: hub.staticIp ?  hub.ipAddress : response.body.bodyContent.hubIP[0] + '.' + response.body.bodyContent.hubIP[1] + '.' + response.body.bodyContent.hubIP[2] + '.' + response.body.bodyContent.hubIP[3] ,
        firmWareYear: response.body.bodyContent.firmwareYear,
        firmWareMonth: response.body.bodyContent.firmwareMonth,
        isMQTTConnected: response.body.bodyContent.isMQTTConnected == 1 ? true : false,
        wifiType: response.body.bodyContent.wifiType == 0 ? "STA" : "AP",
        ssid: response.body.bodyContent.ssid,
        dateStamp: response.header.nonce.dateStamp,
        timeStamp: response.header.nonce.timeStamp,
        ioInfo: response.body.bodyContent.ioInfo
      });
      if(store.state.hubs[hubIndex].connectionStatus.local != CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        store.dispatch('updateNodeListAndStates', response.hubIndex)
        .then( (response) => {
            var nodeStats = response.body.bodyContent.nodeStats;
            nodeStats.hubIndex = response.hubIndex;
            store.dispatch('processNodeListAndStates', nodeStats);
            // store.dispatch('updateAutomations', response.hubIndex)
            // .catch( (response) => {
            //   store.commit('setHubStatus', {
            //     hubIndex: response.hubIndex,
            //     connectionStatus: {
            //       online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            //     },
            //   });
            //   setTimeout( () => {
            //     //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
            //     store.dispatch('checkHubConnectionStatusOnline', store.state.hubs[response.hubIndex].uuid);
            //   }, CONFIGS.updateHubNodeStatusIntervalTime);
            // });
        })
        .catch( (response) => {
          console.log(response);
          store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
          setTimeout( () => {
            //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
            store.dispatch('checkHubConnectionStatusOnline', store.state.hubs[response.hubIndex].uuid);
          }, CONFIGS.updateHubNodeStatusIntervalTime);
        });
      }
    })
    .catch( response => {
      // console.log('in catch');
      console.log(response);
      if(store.state.hubs[response.hubIndex].connectionStatus.local != CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        setTimeout( () => {
          //TODO: this line has a bug when hub is deleted. should work only with uuid everywhere.
          store.dispatch('checkHubConnectionStatusOnline', store.state.hubs[response.hubIndex].uuid);
        }, CONFIGS.updateHubNodeStatusIntervalTime);
      }else{
        store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
    });
  },
}
export default HUB_CONNECTION_ACTIONS;